module.exports = __webpack_public_path__ + "media/images/emblems/Celerina_Schlarigna_wappen-4dcf58c92ccb10b05acaa75222d0d4dd.svg";